module.exports = __webpack_public_path__ + "static/media/md-clipboard.8b029cfd.svg";